import { useQuery } from '@tanstack/react-query';
import { pagoGlobalApi } from '@/data/api/pagoGlobalApi';
const KEY = 'pagos-global';
export function usePagosGlobales(filtros) {
    return useQuery({
        queryKey: [KEY, filtros],
        queryFn: () => pagoGlobalApi.listar(filtros),
        placeholderData: (previous) => previous,
    });
}
export function usePagoDetalle(id) {
    return useQuery({
        queryKey: [KEY, 'detalle', id],
        queryFn: () => pagoGlobalApi.ver(id),
        enabled: Boolean(id),
    });
}
